import 'moment/locale/ja';
import { CouponIssued } from '../../entity/coupon-issued.entity';
import { ShopToken } from '../../entity/shop-token.entity';

import { CxCouponIssued } from '../../entity/cx-coupon-issued.entity';
import { CxShopToken } from '../../entity/cx-shop-token.entity';
import { Branches } from '../../entity/branches.entity';


export const APP_MODE_V = {
  shopqr: 'shopqr',
  coupon: 'coupon',
} as const;

export type APP_MODE = typeof APP_MODE_V[keyof typeof APP_MODE_V];

export interface ResDataStartSession {
  appSession: AppSession,
  shopToken: ShopToken|null,
  couponIssued: CouponIssued|null,
}

export interface HttpRes {
  isError: boolean,
  messages: {
    isError: boolean,
    message: string,
  }[],
  isTest: boolean,
  data: null|ResDataStartSession,
}

export interface AppSession {
  appMode: APP_MODE,
  shopqr: {
    token: {
      valid: boolean,
      id: number,
    },
    questionHeaderId: number,
    answerHeaderId: number,
    questionIds: number[];
    survey: {
      answered: boolean,
    },
    registeredEmail: boolean,
    couponId: number|null,
    couponIssuedId: number|null,
  }|null,
  showCoupon: {
    couponIssuedId: number|null,
  }|null,
}

export interface CxResDataStartSession {
  cxAppSession: CxAppSession,
  cxShopToken: CxShopToken|null,
  cxCouponIssued: CxCouponIssued|null,
  branches?: Branches[],
}

export interface CxHttpRes {
  isError: boolean,
  messages: {
    isError: boolean,
    message: string,
  }[],
  isTest: boolean,
  data: null|CxResDataStartSession,
}


export interface CxAppSession {
  appMode: APP_MODE,
  shopqr: {
    token: {
      valid: boolean,
      id: number,
      isCommon: boolean,
    },
    cxQuestionHeaderId: number,
    cxAnswerHeaderId: number,
    cxQuestionIds: number[];
    survey: {
      answered: boolean,
    },
    registeredEmail: boolean,
    cxCouponId: number|null,
    cxCouponIssuedId: number|null,
  }|null,
  showCoupon: {
    cxCouponIssuedId: number|null,
  }|null,
}


export interface CommonSession {
  isTest: boolean,
}

export interface CxRootSession {
  common: CommonSession,
  cxAppSession: CxAppSession,
}
